import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { CrazyCallConfigService } from '../lead-generation/shared/services/crazycall-config.service';
import { Project } from '../lead-generation/shared/models/Project';
import {
  GET_REPORTS_META_DATA,
  GET_OVERALL_REPORTS_META_DATA,
  GET_PROJECTS,
  GetMetaDataFailureAction,
  GetMetaDataSuccessAction,
  GetOverallMetaDataFailureAction,
  GetOverallMetaDataSuccessAction,
  GetProjectsFailureAction,
  GetProjectsSuccessAction,
  ReportsAction
} from './reports.actions';
import { ReportMetaData } from './report';
import { ReportsService } from './reports.service';

@Injectable()
export class ReportsEffects {
  constructor(
    private actions$: Actions,
    private crazyCallConfigService: CrazyCallConfigService,
    private reportService: ReportsService
  ) {}

  @Effect()
  getProjects: Observable<ReportsAction> = this.actions$.pipe(
    ofType(GET_PROJECTS),
    switchMap(() =>
      this.crazyCallConfigService
        .getProjects()
        .pipe(
          map((response: Project[]) => new GetProjectsSuccessAction(response)),
          catchError(error => of(new GetProjectsFailureAction(error)))
        )
    )
  );

  @Effect()
  getMetaData: Observable<ReportsAction> = this.actions$.pipe(
    ofType(GET_REPORTS_META_DATA),
    switchMap(() =>
      this.reportService
        .getReportMetaData()
        .pipe(
          map((response: ReportMetaData) => new GetMetaDataSuccessAction(response)),
          catchError(error => of(new GetMetaDataFailureAction(error)))
        )
    )
  );

  @Effect()
  getOverallMetaData: Observable<ReportsAction> = this.actions$.pipe(
    ofType(GET_OVERALL_REPORTS_META_DATA),
    switchMap(() =>
      this.reportService
        .getReportOverallMetaData()
        .pipe(
          map((response: ReportMetaData) => new GetOverallMetaDataSuccessAction(response)),
          catchError(error => of(new GetOverallMetaDataFailureAction(error)))
        )
    )
  );
}
